module.exports = __webpack_public_path__ + "static/dealersys long black-825e7bb2e9a16a9ac10bda699102e9ea.png";